import React from "react";
import { useSelector } from "react-redux";

import Classes from "./styles/style.module.css";
import UserListElement from "./UserListElement";
import NoResultAlter from "../../../assets/components/UI/NoResultAlter";

const UsersRateList = ({ type }) => {
  const { leaderBoardData } = useSelector(({ quiz }) => quiz);
  const { currentUser } = useSelector(({ user }) => user);

  let userSelf = leaderBoardData
    ? leaderBoardData.find((user) => user.userId === currentUser._id)
    : null;

  let currentUserRate = leaderBoardData
    ? leaderBoardData.indexOf(
        leaderBoardData.find((user) => user.userId === currentUser._id)
      )
    : 0;

  let allUsers = leaderBoardData
    ? leaderBoardData.length > 3
      ? leaderBoardData
          .slice(3)
          .filter((user) => user.userId !== currentUser._id)
      : []
    : [];

  return (
    <div className={Classes.usersRateContainer}>
      <div className={Classes.ratesContainer}>
        {userSelf ? (
          <UserListElement
            score={userSelf.totalScore}
            name={userSelf.fullName}
            rate={currentUserRate + 1}
            key={currentUserRate}
            profile={userSelf.profileImage}
            type={type}
          />
        ) : null}
        {allUsers.length !== 0
          ? allUsers.map((user, index) => (
              <UserListElement
                id={user.userId}
                score={user.totalScore}
                name={user.fullName}
                rate={
                  leaderBoardData.indexOf(
                    leaderBoardData.find((el) => el.userId === user.userId)
                  ) + 1
                }
                key={index}
                profile={user.profileImage}
                type={type}
              />
            ))
          : !userSelf && <NoResultAlter />}
      </div>
    </div>
  );
};

export default UsersRateList;
